import script from "./VTableTrTotal.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableTrTotal.vue?vue&type=script&setup=true&lang=js"

import "./VTableTrTotal.vue?vue&type=style&index=0&id=fd05d7d2&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd05d7d2"]])

export default __exports__